export const defaultSideBarWithColumnsToolPanel = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressSideButtons: true,
        suppressColumnFilter: true,
        suppressColumnSelectAll: true,
        suppressColumnExpandAll: true,
      },
    },
  ],
};

export const defaultSideBarWithColumnsToolPanelSelectAll = {
  toolPanels: [
    {
      ...defaultSideBarWithColumnsToolPanel.toolPanels[0],
      toolPanelParams: {
        ...defaultSideBarWithColumnsToolPanel.toolPanels[0].toolPanelParams,
        suppressColumnSelectAll: false,
      },
    },
  ],
};

export const gridPivotOptions = {
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: '',
  },
  pivotPanelShow: 'always',
  rowGroupPanelShow: 'always',
  enableRangeSelection: true,
  enableCharts: true,
  groupIncludeFooter: true,
  autoGroupColumnDef: {
    cellRendererParams: {
      suppressCount: true,
    },
  },
  suppressAggFuncInHeader: true,
};

/**
 * AG Grid 32+ defaults rowSelection.checkboxes to true, which adds a dedicated selection column.
 * Use with column definitions that already set `checkboxSelection` / `headerCheckboxSelection`
 * so only that column shows checkboxes (avoids duplicate checkbox columns).
 */
export const rowSelectionMultiRowWithColumnCheckboxes = {
  mode: 'multiRow',
  checkboxes: false,
  headerCheckbox: false,
};

/** Shared row-group panel / edit flags for checkbox-group workpaper grids. */
export const gridGroupOptions = {
  rowGroupPanelShow: 'never',
  enableGroupEdit: true,
};

const groupLabelForSort = (checkboxGroups, key) => {
  if (key == null || key === '') {
    return '';
  }
  const id = String(key);
  const name = checkboxGroups.find(g => g.id === id)?.name;
  return (name || id).toLowerCase();
};

/**
 * Row grouping UX for State Specific / State Common (and related) screens:
 * rows without a checkbox group render as normal rows first; real groups follow,
 * collapsed by default, ordered by Group / Account name.
 *
 * Stable row ids: data rows use rowId; group nodes use only the group key (rowIndex changes would
 * swap ids and destroy editors).
 */
export const getCheckboxGroupWorkpaperRowId = params => {
  if (params.node?.group) {
    const key = params.node.key != null ? String(params.node.key) : 'group';
    return `g-${key}`;
  }
  const id = params.data?.rowId;
  if (id !== undefined && id !== null) {
    return String(id);
  }
  if (params.node?.id != null) {
    return String(params.node.id);
  }
  return 'row-unknown';
};

export const getCheckboxGroupGridOptions = (checkboxGroups = []) => ({
  ...gridGroupOptions,
  rowSelection: {
    mode: 'singleRow',
    checkboxes: false,
    headerCheckbox: false,
    enableClickSelection: true,
  },
  // Defer selection so AG Grid can finish starting the cell editor on the same click.
  // Synchronous setSelected here was stealing layout/focus and forced a second click to open native <select>.
  onCellClicked: params => {
    if (params.node) {
      requestAnimationFrame(() => {
        params.node.setSelected(true, true);
      });
    }
  },
  onRowClicked: params => {
    if (params.node) {
      requestAnimationFrame(() => {
        params.node.setSelected(true, true);
      });
    }
  },
  isRowSelectable: () => true,
  groupAllowUnbalanced: true,
  groupDefaultExpanded: 0,
  initialGroupOrderComparator: ({ nodeA, nodeB }) => {
    if (nodeA.group !== nodeB.group) {
      return nodeA.group ? 1 : -1;
    }
    if (!nodeA.group) {
      return 0;
    }
    const a = groupLabelForSort(checkboxGroups, nodeA.key);
    const b = groupLabelForSort(checkboxGroups, nodeB.key);
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  },
});

export const EXCEL_TEXT_FORMAT = 'excelTextFormat';
export const EXCEL_NUMBER_FORMAT = 'excelNumberFormat';

export const excelStyles = [
  {
    id: EXCEL_TEXT_FORMAT,
    dataType: 'string',
  },
  {
    id: EXCEL_NUMBER_FORMAT,
    dataType: 'number',
  },
];
